const data = {
  en: {
    text: "Hello World!",
    text2: "Hello Universe!",
  },
  de: {
    text: "Hallo Welt!",
  },
};

export { data };
